// this file will hold settings for the JM API

export const KEY = "abc12341";

// openroute API key
export const OPENROUTE_API_KEY =
  "5b3ce3597851110001cf624898a2298dd18d47e790165c19b354d96a";
